import { IconButton } from '@/shared/ui'
import { useThemeStore } from '@/shared/lib/theme'

export function ThemeToggle() {
  const toggle = useThemeStore((s) => s.toggle)
  // 16/1.8 — prototype/Prototype.dc.html:210. У каждой иконки шапки свои значения, см. IconButton.
  return <IconButton icon="theme" title="Тема" size={16} strokeWidth={1.8} onClick={toggle} />
}
